/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { provincesService } from '../../_services/provinces.service'
import Modal from 'react-responsive-modal'
import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai"
// import PicUploader3 from '../Shared/PicUploader3'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from "react-table"

import { Input } from 'antd'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import { FaPlus } from 'react-icons/fa'
import { FiEdit, FiCheckCircle, FiCircle } from 'react-icons/fi'
import { FiTrash2 } from 'react-icons/fi'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

class Provinces extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      initialItems: [],
      data: [],
      modal: false,
      modalHeading: '',
      loading: true,
      confirmDeleteShow: false,
      deleteItemIndex: 0,
      model: { name: '' }
    }

    this.getData()
  }

  handleModalCreate = () => {
    this.setState({ modalHeading: 'ثبت استان جدید', modal: true, model: { name: '' } });
  }

  handleModalEdit = (e) => {
    let _model = this.state.data[e];
    this.setState({ modal: true, model: _model, modalHeading: 'ویرایش استان "' + _model.name + '"' });
  }

  handleModalHide = (e) => {
    var evt = e || window.event; // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault();
    }
    this.setState({ modal: false });
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false });
  }

  getData() {
    provincesService.getAll()
      .then((res) => {
        // console.log(res.data)
        this.setState({ initialItems: res.data, data: res.data, loading: false, isSubmitting: false, modal: false });
      })
      .catch((error) => {
        this.handleError(error)
      });
  };


  handleError(error) {
    this.setState({ loading: false });
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = (e) => {
    let _model = this.state.data[e];

    this.setState({ confirmDeleteShow: true, model: _model });
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false });

    provincesService.delete(this.state.model.id)
      .then((res) => {
        toastr.success('حذف استان', 'استان با موفقیت حذف شد');
        this.getData();
      })
      .catch((error) => {
        this.handleError(error)
      });
  }

  handleSubmit = (values) => {
    this.setState({ loading: true });
    // console.log(JSON.stringify(values));

    if (values.id) {

      provincesService.edit(values.id, JSON.stringify(values))
        .then((res) => {

          toastr.success('ویرایش استان', 'استان "' + values.name + '" با موفقیت ویرایش شد');
          this.setState({ modal: false });
          this.getData();

        })
        .catch((error) => {
          this.handleError(error)
        });

    } else {

      provincesService.add(JSON.stringify(values))
        .then((res) => {

          toastr.success('ثبت استان جدید', 'استان "' + res.data.name + '" با موفقیت ثبت شد');
          this.setState({ modal: false });
          this.getData();

        })
        .catch((error) => {
          this.handleError(error)
        });

    }
  }

  render() {

    const ValidationSchema = Yup.object().shape({
      name: Yup.string().trim().required('نام استان'),
      // nameLatin: Yup.string().trim().required('لاتین نام استان'),
    });
    const { model, loading } = this.state;
    return (
      <div>
        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            data={this.state.data}
            filterable

            previousText='صفحه قبل'
            nextText='صفحه بعد'
            loadingText='در حال بارگذاری ...'
            noDataText='نتیجه ای یافت نشد'
            pageText='صفحه'
            ofText='از'
            rowsText='تعداد نمایش'

            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value}
            columns={[
              {
                Header: "ردیف",
                id: "row",
                maxWidth: 50,
                filterable: false,
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                className: "numberFa",
                Cell: (row) => {
                  return row.index + 1;
                }
              },
              {
                Header: "نام استان",
                accessor: "name",
                id: "name",
                style: { display: 'flex', alignItems: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["name"], threshold: matchSorter.rankings.CONTAINS }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
              },
              {
                Header: "ویرایش",
                accessor: 'id',
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                sortable: false,
                // filterable: false,
                Filter: ({ filter, onChange }) =>
                  <a onClick={this.handleModalCreate} className="btn btn-primary react-table-add-btn"
                  >
                    <span>
                      <FaPlus size="16px" />
                      <span>افزودن استان جدید</span>
                    </span>
                  </a>,
                Cell: row => (
                  <div>
                    <a onClick={() => this.handleModalEdit(row.index)} className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn" rel="tooltip" data-original-title="ویرایش"><FiEdit size="24px" /></a>
                    <a onClick={() => this.handleDelete(row.index)} className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn" data-original-title="حذف" rel="tooltip"><FiTrash2 size="24px" /></a>
                  </div>
                )
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />

        </div>
        <Modal open={this.state.modal} onClose={this.handleModalHide} center
          classNames={{
            overlay: "customOverlay",
            modal: "customModal",
            closeButton: "customModalCloseButton",
          }}>

          <Formik
            initialValues={model}
            onSubmit={(values, { setSubmitting }) => {
              // // console.log(values);
              this.handleSubmit(values)
            }}
            validationSchema={ValidationSchema}
          >
            {props => {
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                setFieldValue,
                handleSubmit,
              } = props;
              return (

                <div className="row" style={{ position: "relative" }}>
                  <div className="col-md-12">
                    <form onSubmit={handleSubmit}>

                      <div className="row">
                        <div className="form-inline">

                          <div className="col-md-12">
                            <label className="pull-right">نام استان</label>
                            <Field type="text"
                              autoFocus
                              name="name"
                              className={
                                getIn(errors, "name") &&
                                  getIn(touched, "name")
                                  ? "text-input has-error rtl"
                                  : "text-input required rtl"
                              }
                            />
                            <ErrorMessage component={ErrorPopUp} name="name" />
                          </div>

                          {/* <div className="col-md-12">
                            <label className="pull-right">لاتین نام استان</label>
                            <Field type="text"
                              name="nameLatin"
                              className={
                                getIn(errors, "nameLatin") &&
                                  getIn(touched, "nameLatin")
                                  ? "text-input has-error rtl"
                                  : "text-input required rtl"
                              }
                            />
                            <ErrorMessage component={ErrorPopUp} name="nameLatin" />
                          </div> */}

                          {/* <div className="col-md-12">
                            <label className="pull-right">تصویر</label>
                            <PicUploader3 label="تصویر"
                              value={values.flagPath}
                              defaultValue={values.flagPath}
                              onChange={(val) => {
                                // console.log(val);
                                setFieldValue('flagPath', val);
                              }}
                            />
                            <ErrorMessage component={ErrorPopUp} name="flagPath" />
                          </div> */}

                          <div className="col-md-12">
                            <br />
                            <input type="hidden" name="id" value={values.id} />
                            <button type="submit" className={"icon button submit-btn " + (isSubmitting ? "isSubmitting" : "")} disabled={isSubmitting} >
                              {isSubmitting ?
                                <AiOutlineLoading className="mdi-spin" size="22px" />
                                :
                                <AiOutlineSave size="22px" />

                              }
                              ذخیره
            </button>
                          </div>

                        </div>
                      </div>


                    </form>
                  </div>
                </div>

              );
            }}
          </Formik>
        </Modal>

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={"آیا از حذف استان [" + this.state.model.name + "] مطمئن هستید؟"}
        >
        </MySweetAlert>

      </div>
    );
  }
}

export default Provinces;
